<template>
   
    <div class="container">
        <div class="row">
            <div class="col-12">
                <h1 class="page-title color-blue">Página en mantenimiento</h1>
                <p class="text-center"><b>Disculpe las molestias, estamos trabajando para mejorar su experiencia</b></p>
            </div>
        </div>
        <div class="row imagen" >
            <div class="col-12">
                <img v-bind:src="require('../assets/img/mantenimiento.png')" alt="logo" class="imagen">
            </div>
        </div>
    </div>

</template>

<script setup>
 export default {
    name: 'PaginaMantenimiento',
    data() {
        return {
        text: "logo mantenimiento"
        }
    }
 }

</script>

<style>
    .imagen{
        display: block;
        margin-right: auto;
        margin-left: auto;
    }

    p{
        text-align: center;
    }
</style>